import * as styles from './Controls.module.css'

import React, { useCallback, useMemo } from 'react'
import classNames from 'classnames'

interface Props {
  selectedSets: Record<string, boolean>
  setSelectedSets: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
}

const Controls: React.FC<Props> = ({ selectedSets, setSelectedSets }) => {
  const sets = useMemo(() => {
    return Object.keys(selectedSets)
  }, [selectedSets])

  const selectAll = useCallback(() => {
    setSelectedSets(Object.fromEntries(sets.map((s) => [s, true])))
  }, [setSelectedSets, sets])

  const selectNone = useCallback(() => {
    setSelectedSets(Object.fromEntries(sets.map((s) => [s, false])))
  }, [setSelectedSets, sets])

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const value = event.currentTarget.value

      setSelectedSets({
        ...selectedSets,
        [value]: !selectedSets[value],
      })
    },
    [selectedSets, setSelectedSets],
  )

  return (
    <div className={styles.container}>
      <div className={styles.label}>Sort by change in play rate:</div>

      <div className={styles.buttons}>
        <div className={styles.sets}>
          {sets.map((set) => (
            <button
              type="button"
              key={set}
              value={set}
              onClick={onClick}
              className={classNames(styles.button, {
                [styles.selected]: selectedSets[set],
              })}
            >
              {set}
            </button>
          ))}
        </div>

        <div>
          <button
            type="button"
            onClick={selectAll}
            className={classNames(styles.button, {
              [styles.selected]: !Object.values(selectedSets).includes(false),
            })}
          >
            All
          </button>
        </div>

        <div>
          <button
            type="button"
            onClick={selectNone}
            className={classNames(styles.button, {
              [styles.selected]: !Object.values(selectedSets).includes(true),
            })}
          >
            None
          </button>
        </div>
      </div>
    </div>
  )
}

export default Controls
